import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { EmailSettings, UpdateEmailSettingsData, TestEmailResult } from '@/types';

export const emailSettingsKeys = {
  all: ['email-settings'] as const,
  settings: () => [...emailSettingsKeys.all, 'settings'] as const,
};

export function useEmailSettings() {
  return useQuery({
    queryKey: emailSettingsKeys.settings(),
    queryFn: async () => {
      const response = await api.get<EmailSettings | null>('/settings/email');
      return response.data;
    },
  });
}

export function useUpdateEmailSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateEmailSettingsData) => {
      const response = await api.patch<EmailSettings>('/settings/email', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailSettingsKeys.settings() });
    },
  });
}

export function useTestEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (recipientEmail: string) => {
      const response = await api.post<TestEmailResult>('/settings/email/test', {
        recipientEmail,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailSettingsKeys.settings() });
    },
  });
}
